/**
 *
 * ReaderModeBook
 *
 */

import { delay } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import FreeModeBook from '@/scripts/FreeMode/FreeModeBook/FreeModeBook';
import Exercise from '@/scripts/Exercise/Exercise';

export default {
  name: 'ReaderModeBook',

  mixins: [FreeModeBook, Exercise],

  components: {},

  data: () => {
    return {};
  },

  computed: {
    ...mapGetters('ReaderModeBook/FreeModeBook', {
      Book: 'Book',
      isRequest: 'isRequest',
      ReadyToPlayVideos: 'ReadyToPlayVideos',
    }),

    ...mapGetters('ReaderModeBook/Exercise', {
      isRequest: 'isRequest',
      QuestionList: 'QuestionList',
      Question: 'Question',
      FirstFilterList: 'FirstFilterList',
      CourseAnalysis: 'CourseAnalysis',
      PzFilterData: 'PzFilterData',
      AfterExerciseData: 'AfterExerciseData',

      isBookLevelUp: 'isBookLevelUp',
      isCourseLevelUp: 'isCourseLevelUp',

      bookLevelUpTo: 'bookLevelUpTo',
      courseLevelUpTo: 'courseLevelUpTo',
      books: 'books',

      BookList: 'BookList',
    }),

    //FreeModeBook
    CourseId: function () {
      if (this.Book && this.Book.courseId) {
        return this.Book.courseId;
      } else {
        return Number.parseInt(this.$route.params.bookId);
      }
    },

    BookId: function () {
      return this.$route.params.bookId;
    },

    //Exercise
    courseId: function () {
      if (this.PzFilterData && this.PzFilterData.studentFilter) {
        return this.PzFilterData.studentFilter.courseId;
      } else if (this.PzFilterData && null === this.PzFilterData.studentFilter) {
        return this.CourseId;
      } else {
        return Number.parseInt(this.$route.params.bookId);
      }
    },
  },

  methods: {
    ...mapActions('ReaderModeBook/FreeModeBook', {
      getBook: 'getBook',
      addToFavoriteList: 'addToFavoriteList',
      generateFile: 'generateFile',
    }),

    ...mapActions('ReaderModeBook/Exercise', {
      getQuestionList: 'getQuestionList',
      answer: 'answer',
      noteSaved: 'noteSaved',
      getQuestion: 'getQuestion',
      getFirstFilterList: 'getFirstFilterList',
      getPzFilterData: 'getPzFilterData',
      markQuestion: 'markQuestion',
      getCourseAnalysis: 'getCourseAnalysis',
      getAfterExerciseData: 'getAfterExerciseData',
      removeWrongList: 'removeWrongList',
    }),

    //FreeModeBook
    changeBulletStatus(video, status) {
      this.$store.commit('ReaderModeBook/FreeModeBook/SET_BULLET_STATUS', { video, status });
    },

    //Exercise
    getCourseAnalysisData() {},

    getQuestions(payload) {
      this.$store.commit('ReaderModeBook/Exercise/GET_FIRST_FILTER_LIST_SUCCESS', []);
      this.getQuestionList({
        practiceType: payload.practiceType,
        courseId: this.courseId,
        bookId: payload.bookId,
        readingId: payload.readingId,
        bulletId: payload.bulletId,
        subjectId: payload.subjectId,
        attribute: payload.attribute,
        inFilter: payload.inFilter ? payload.inFilter : false,
      });
    },

    clearData() {
      this.$store.commit('ReaderModeBook/Exercise/GET_QUESTION_LIST_SUCCESS', []);
      this.$store.commit('ReaderModeBook/Exercise/GET_QUESTION_SUCCESS', {});
      this.$store.commit('ReaderModeBook/Exercise/GET_FIRST_FILTER_LIST_SUCCESS', []);
      this.$store.commit('ReaderModeBook/Exercise/GET_AFTER_EXERCISE_SUCCESS', {});
      this.$store.commit('ReaderModeBook/Exercise/GET_PZ_FILTER_DATA_SUCCESS', {});
    },

    setQuestion(payload) {
      this.$store.commit('ReaderModeBook/Exercise/SET_QUESTION', payload);
    },

    closeBookListMasterAchieved() {
      this.isShowBookListMasterAchieved = false;
      this.clearData();
      this.$store.commit('ReaderModeBook/Exercise/SET_BOOK_LEVEL_UP_STATUS', false);
    },

    closeCourseLevelUp() {
      this.isShowCourseLevelUp = false;
      this.clearData();
      this.$store.commit('ReaderModeBook/Exercise/SET_COURSE_LEVEL_UP_STATUS', false);
    },

    resetBookLevelUpStatus() {
      delay(() => {
        this.$store.commit('ReaderModeBook/Exercise/SET_BOOK_LEVEL_UP_STATUS', false);
      }, 3000);
    },

    resetCourseLevelUpStatus() {
      delay(() => {
        this.$store.commit('ReaderModeBook/Exercise/SET_COURSE_LEVEL_UP_STATUS', false);
      }, 3000);
    },
  },
};
